<template>
  <section class="bg-white py-20">
    <div class="co-container-sm mx-auto px-4">
      <div class="flex items-start justify-center">
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          width="14"
          height="15"
          loading="lazy"
        >
        <div class="ya-te-text-red co-display-11 mb-2 px-2 font-bold leading-normal">
          お得に学べる補助金制度
        </div>
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          style="transform: scale(-1, 1)"
          width="14"
          height="15"
          loading="lazy"
        >
      </div>
      <h2 class="ya-te-page-title ya-te-text-primary mb-5 text-center font-extrabold sm:mb-12">
        受講料の最大70％を<br class="md:hidden">キャッシュバック
      </h2>
      <div class="flex flex-col items-center justify-center gap-5 md:flex-row md:gap-8">
        <div class="w-60 min-w-60">
          <img
            src="~/assets/images/YaTe/YaTeCounseling/Reskilling/reskilling-logo.svg"
            alt="バーチャル空間を活用して学習をサポート"
            width="240"
            height="133"
            loading="lazy"
            class="mx-auto"
          >
        </div>
        <div>
          <p class="mb-3">
            LINEヤフーテックアカデミーは経済産業省の「リスキリングを通じたキャリアアップ支援事業」に採択されています。
            <br>
            条件を満たすことで、受講料の最大<span class="co-display-10 font-bold">70</span>％（35万円）が補助されます。
          </p>
          <div class="co-display-14 leading-normal text-co-gray-500">
            所定の条件を満たし受講修了した場合に50%還元、転職成功した場合には転職先企業で1年間就業すると追加で20%の還元を受けられます。詳細は<a
              href="https://ly-academy.yahoo.co.jp/tech/services/benefits"
              target="_blank"
            >こちら
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
</style>
